import queryString from 'query-string';

import timedFetch from 'middleware/timedFetch';

export const ENDPOINT_OPAL_EXPLICITFITS = '/opalSizingAuth/explicit/fits';

/**
 * Get product sizing prediction
 * @param  {object}   url             sizing prediction api endpoint
 * @param  {object}   productId       product id
 * @param  {function} [fetcher=fetch] fetch or fetch like implementation
 * @return {object}                   promise
 */
export function sizingPrediction({ url }, { productId, hydraSop }, fetcher = timedFetch('sizingPrediction')) {
  let endpoint = '/sizing/prediction';
  const queryParams = {
    productId
  };

  if (hydraSop) {
    endpoint = '/sizing/v2/prediction';
    queryParams.ignoreCustomerForOnDemandEligible = true;
  }

  const query = queryString.stringify(queryParams);
  const reqUrl = `${url}${endpoint}?${query}`;
  return fetcher(reqUrl, {
    method: 'GET',
    credentials: 'include'
  });
}

/**
 * Get on-demand sizing prediction
 * @param  {object}   url             on-demand sizing prediction api endpoint
 * @param  {object}   reqData         productId, productSize, brandId, productCategory, gender
 * @param  {function} [fetcher=fetch] fetch or fetch like implementation
 * @return {object}                   promise
 */
export function sizingPredictionOnDemand({ url }, reqData, fetcher = timedFetch('sizingPredictionOnDemand')) {
  const { productId, productSize, brandId, productCategory, gender, hydraSop } = reqData;

  let endpoint = '/sizing/prediction/onDemand';

  const queryParams = {
    productId,
    size: productSize,
    brandId,
    productCategory
  };

  if (gender) {
    queryParams.gender = gender;
  }

  if (hydraSop) {
    endpoint = '/sizing/v2/prediction/onDemand';
    queryParams.ignoreCustomerForOnDemandEligible = true;
  }

  const query = queryString.stringify(queryParams);
  const reqUrl = `${url}${endpoint}?${query}`;
  return fetcher(reqUrl, {
    method: 'GET',
    credentials: 'include'
  });
}

/**
 * Get a list of supported brands for on-demand sizing prediction
 * @param  {object}   url             supported brands api endpoint
 * @param  {object}   gender          gender ("Men" or "Women")
 * @param  {function} [fetcher=fetch] fetch or fetch like implementation
 * @return {object}                   promise
 */
export function supportedBrands({ url }, gender, fetcher = timedFetch('sizingSupportedBrands')) {
  const reqUrl = `${url}/sizing/supportedBrands?gender=${gender}`;
  return fetcher(reqUrl, {
    method: 'GET',
    credentials: 'include'
  });
}

/**
 * Get opal profile
 * @param  {object}   url             opal url
 * @param  {function} [fetcher=fetch] fetch or fetch like implementation
 * @return {object}                   promise
 */
export function profile({ url }, fetcher = timedFetch('profile')) {
  const reqUrl = `${url}/customer/customerProfile`;
  return fetcher(reqUrl, {
    method: 'GET',
    credentials: 'include'
  });
}
